import api from "@/api";

export default {
  namespaced: true,
  state: () => ({
    currentGroup: null,
    isLoading: false,
    error: null,
    students: [],
    filters: {
      search: "",
      gender: "",
      national_num: ""
    },
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0
    }
  }),
  mutations: {
    SET_CURRENT_GROUP(state, group) {
      state.currentGroup = group;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_STUDENTS(state, students) {
      state.students = Array.isArray(students) ? students : [];
    },
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters };
    },
    RESET_FILTERS(state) {
      state.filters = {
        search: "",
        gender: "",
        national_num: ""
      };
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = {
        current_page: Number(pagination.current_page) || 1,
        per_page: Number(pagination.per_page) || 10,
        total: Number(pagination.total) || 0,
        last_page: Number(pagination.last_page) || 1,
        from: Number(pagination.from) || 0,
        to: Number(pagination.to) || 0
      };
    }
  },
  actions: {
    async fetchGroupStudents({ commit, state }, { classId, groupId }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const params = {
          page: Number(state.pagination.current_page) || 1,
          per_page: Number(state.pagination.per_page) || 10,
          ...Object.fromEntries(
            Object.entries(state.filters).filter(
              ([, value]) => value !== "" && value !== null && value !== undefined
            )
          )
        };

        const { data } = await api.get(`/classes/${classId}/groups/${groupId}/students`, { params });

        commit("SET_STUDENTS", data.data);

        if (data.meta) {
          commit("SET_PAGINATION", {
            current_page: data.meta.current_page,
            last_page: data.meta.last_page,
            per_page: data.meta.per_page,
            total: data.meta.total,
            from: data.meta.from,
            to: data.meta.to
          });

          // Optionally store current group/class
          if (data.meta.group) {
            commit("SET_CURRENT_GROUP", data.meta.group);
          }
        }

        return data;
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchGroup({ commit }, { classId, groupId }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const { data } = await api.get(`/classes/${classId}/groups/${groupId}`);
        commit("SET_CURRENT_GROUP", data.data);
        return data;
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async assignGroupToClass({ commit }, { classId, group_id }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const { data } = await api.post(`classes/${classId}/assign-group`, { group_id });
        return data;
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    }
  },
  getters: {
    getCurrentGroup: (state) => state.currentGroup,
    getPagination: (state) => state.pagination,
    getStudents: (state) => state.students,
    getFilters: (state) => state.filters,
    isLoading: (state) => state.isLoading,
    getError: (state) => state.error
  }
};
